<div class="modal-default" data-remodal-id="modal-delete">
  <div class=".alert-icon">
      <img src="./assets/images/{{modalError ? 'ico-high-warning' : 'ico-alert-circle'}}.svg" alt="Icone de alerta">
  </div>
  <div class="modal-default__content">
      <h1>{{confirmMessage}}</h1>
      <p>{{menssageSubtitle}}</p>
      <p></p>
  </div>
  <div class="modal-default__buttons">
    <button *ngIf="cancelButton" (click)="dialogDefault.close(false)" class="button-link" data-test="btnCancelModal">Cancelar</button>
    <button (click)="dialogDefault.close(true)" class="button-confirm" data-test="btnSaveModal">{{ confirmMessageButton || 'Confirmar'}}</button>
</div>
</div>
